import { useTranslation } from "react-i18next";

/**
 * O selo "Preliminar" do RF-09, o mesmo no tile e no frame. O frame diz quantos
 * itens faltam no próprio selo; o tile diz numa linha abaixo do número.
 */
export function PreliminaryBadge({ undecided }: { undecided?: number }) {
  const { t } = useTranslation();
  return (
    <span className="rounded bg-[#fff5d6] px-1.5 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-[0.06em] text-[#6f4e00]">
      {undecided == null
        ? t("Preliminary")
        : t("Preliminary · {{count}} with no disposition", { count: undecided })}
    </span>
  );
}
